"use strict";

exports.__esModule = true;

var _a;

exports.BigInt = (_a = require('jsbi/dist/jsbi-umd'), _a.BigInt), exports.toNumber = _a.toNumber, exports.equal = _a.equal, exports.greaterThan = _a.greaterThan, exports.lessThan = _a.lessThan, exports.greaterThanOrEqual = _a.greaterThanOrEqual, exports.lessThanOrEqual = _a.lessThanOrEqual, exports.add = _a.add, exports.divide = _a.divide, exports.subtract = _a.subtract, exports.multiply = _a.multiply, exports.exponentiate = _a.exponentiate;
exports.ZERO = exports.BigInt(0);

exports.biEqual = function (a, b) {
  return exports.equal(exports.bi(a), exports.bi(b));
};

exports.biMax = function (a, b) {
  if (exports.greaterThan(exports.bi(a), exports.bi(b))) return exports.bi(b);
  return exports.bi(a);
};

exports.bi = function (value) {
  if (typeof value === 'string') {
    return exports.BigInt(Number(value) ? value : 0);
  }

  return exports.BigInt(value || '');
};

exports.isBigInt = function (value) {
  return value.constructor.__isBigInt && value.constructor.__isBigInt(value);
};